import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketConsultants from "components/Market/Consultants/MarketConsultants";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketConsultantsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketConsultants {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateHireConsultant: (consultantId, isHire) => dispatch(marketReducer.updateHireConsultant(consultantId, isHire)),
    updateIsCreateConsultant: (isCreateConsultant) =>
      dispatch(marketReducer.updateIsCreateConsultant(isCreateConsultant)),
    deleteConsultant: (consultantId) => dispatch(marketReducer.deleteConsultant(consultantId))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    consultants: marketReducer.getConsultantsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketConsultantsContainer);
